import { SPEAKING_PHOTOS } from "../../data/config";
import { Reveal } from "../common/Reveal";

export const SpeakingHighlights = () => (
  <section className="bg-cream py-20 lg:py-28" data-testid="speaking-highlights">
    <div className="container-site">
      <Reveal>
        <p className="eyebrow">On stage</p>
        <h2 className="mt-4 font-serif text-3xl tracking-tight text-navy sm:text-4xl">
          Speaking <span className="italic text-emerald">Highlights</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mt-12 flex snap-x gap-4 overflow-x-auto pb-4" data-testid="speaking-strip">
          {SPEAKING_PHOTOS.map((p, i) => (
            <figure
              key={p.src}
              className="group w-60 shrink-0 snap-start sm:w-72"
              data-testid={`speaking-photo-${i + 1}`}
            >
              <div className="overflow-hidden">
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className="aspect-[4/5] w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                />
              </div>
              <figcaption className="mt-3">
                <span className="block text-[10px] font-semibold uppercase tracking-[0.25em] text-gold">
                  {p.tag}
                </span>
                <span className="mt-1 block text-xs text-ink/55">{p.caption}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
